import { CrawlRedirectDialog } from '@components/CrawlRedirectDialog'
import { GeneralConfirm } from '@components/GeneralConfirm'
import { DeleteTab } from '@lib/components/Tabs/Dialogs'

import AttachedFilesDialog from '../../ArtBoard/SettingsSidebar/components/AttachedFiles/AttachedFilesDialog'
import * as DialogTypes from './constants'
import DeleteAvatar from './DeleteAvatarDialog/DeleteAvatarDialog'
import CancelCrawling from './dialogs/CancelCrawling'
import { DiscardCrawl } from './dialogs/DiscardCrawl'
import NewCrawling from './dialogs/NewCrawling'
import StopCrawling from './dialogs/StopCrawling'
import UnsavedChanges from './dialogs/UnsavedChanges'

export default {
  [DialogTypes.CRAWL_REDIRECT]: CrawlRedirectDialog,
  [DialogTypes.NEW_CRAWLING]: NewCrawling,
  [DialogTypes.CANCEL_CRAWLING]: CancelCrawling,
  [DialogTypes.STOP_CRAWLING]: StopCrawling,
  [DialogTypes.DISCARD_CRAWL]: DiscardCrawl,
  [DialogTypes.UNSAVED_CHANGES]: UnsavedChanges,
  [DialogTypes.DELETE_TEAM_AVATAR]: DeleteAvatar,
  [DialogTypes.DELETE_AVATAR]: DeleteAvatar,
  // [DialogTypes.VERSION_HISTORY_RESTORE]: RestoreVersionHistoryDialog,
  [DialogTypes.DELETE_FILE]: AttachedFilesDialog,
  [DialogTypes.DELETE_TAB_DIALOG]: DeleteTab,
  [DialogTypes.GENERAL_CONFIRMATION]: GeneralConfirm,
}
